import { filter, Observable } from 'rxjs'

import { WebsocketAction } from '../model/websocket'

export function filterAction<T extends { action?: string }>(action: WebsocketAction | string) {
  return (observable$: Observable<T>): Observable<T> => {
    return observable$.pipe(filter<T>((payload) => payload.action === action))
  }
}
